"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentItembyID = getContentItembyID;
exports.getContentItembyPath = getContentItembyPath;
exports.parseContentItem = parseContentItem;
var _react = require("react");
var _base = require("./base.functions");
// TODO: cache the results for a given path for a given environment for 24 hours
// TODO: add a force param to invalidate the cache for a given path
// TODO: extract all objects of a given template name or template id

const endpoint = {
  development: 'https://content.test-godaddy.com',
  test: 'https://content.test-godaddy.com',
  production: 'https://content.godaddy.com'
};
function hasHtml(value) {
  return /<\w.+>|&#\d+;/.test(value);
}
function parseContentItem(contentItem) {
  for (const prop in contentItem) {
    if (typeof contentItem[prop] === 'object' && contentItem[prop] !== null) {
      parseContentItem(contentItem[prop]);
    } else if (typeof contentItem[prop] === 'string' && hasHtml(contentItem[prop])) {
      contentItem[prop] = /*#__PURE__*/(0, _react.createElement)('span',
      // eslint-disable-next-line quote-props
      {
        'data-cy': 'has-html',
        dangerouslySetInnerHTML: {
          __html: contentItem[prop]
        }
      });
    }
  }
  return contentItem;
}

// return true if preview mode is enabled (has contextState query param or previewmode cookie)
function isPreviewMode() {
  // access cookies
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(';')?.map(cookie => cookie.trim());
    const previewMode = cookies.find(cookie => cookie.startsWith('previewmode'));
    return previewMode && previewMode.split('=')[1];
  }
  // access query params
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.has('contextState');
  }
  return false;
}
function getBaseUrl(url, draft = false, queryParams) {
  // eslint-disable-next-line no-process-env
  const env = process.env.NODE_ENV || 'development';
  const baseUrl = new URL(url || endpoint[env]);
  // set query params
  if (isPreviewMode() || draft) {
    baseUrl.searchParams.set('contextState', 'draft');
  }
  baseUrl.searchParams.set('format', 'reactv2');
  baseUrl.searchParams.set('marketid', (0, _base.getCookieValue)('market').replace(/"/g, '') || 'en-US');
  baseUrl.searchParams.set('currencyid', (0, _base.getCookieValue)('currency').replace(/"/g, '') || 'USD');
  if (queryParams) {
    Object.keys(queryParams).forEach(key => {
      baseUrl.searchParams.set(key, queryParams[key]);
    });
    baseUrl.search = decodeURIComponent(baseUrl.search);
  }
  return baseUrl;
}

// Content API wrapper
// https://content.dev-godaddy.com/swagger/index.html
// path: godaddy/sales
// eslint-disable-next-line max-params
async function getContentItembyPath(path, draft = false, queryParams = {}, url = null, appKeyHeader = 'fos-pattern-library') {
  if (!path) {
    throw new Error('No path provided');
  }
  const baseUrl = getBaseUrl(url, draft, queryParams);
  baseUrl.pathname = path;
  return await fetch(baseUrl, {
    credentials: 'include',
    headers: {
      'X-App-Key': appKeyHeader
    }
  }).then(res => {
    if (res.status !== 200) {
      throw new Error(`Error fetching content item: ${res.status} ${res.statusText}`);
    }
    return res.json().then(data => {
      return parseContentItem(data);
    });
  });
}

// guid: {DBBB3C5D-562D-411E-941D-4D5E9C206FD9}
// eslint-disable-next-line max-params
async function getContentItembyID(guid, draft = false, parseItem = true, url = null, appKeyHeader = 'fos-pattern-library') {
  if (!guid) {
    throw new Error('No guid provided');
  }
  const baseUrl = getBaseUrl(url, draft);
  baseUrl.pathname = `@id/${guid}`;
  return await fetch(baseUrl, {
    credentials: 'include',
    headers: {
      'X-App-Key': appKeyHeader
    }
  }).then(res => {
    if (res.status !== 200) {
      throw new Error(`Error fetching content item: ${res.status} ${res.statusText}`);
    }
    if (!parseItem) {
      return res.json();
    }
    return res.json().then(data => {
      return parseContentItem(data);
    });
  });
}